const getLineInfo = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const lineId = urlParams.get('lineId')
    if (lineId) {
        sessionStorage.setItem('lineId', lineId)
    }
}
getLineInfo()